export const genrateTds = [
  { id: 11, sec: '194C', value: 1, other: 1, label: '194C Contractor-During the F [1%]' },
  { id: 113, sec: '194C', value: 2, other: 2, label: '194C Contractor-During the F [2%]' },
  { id: 12, sec: '194C', value: 0, other: 0, label: '194C Transporter (44AE) Declar [0%]' },
  { id: 19, sec: '194H', value: 5, other: 5, label: '194H Commission/Brokerage [5%]' },
  { id: 20, sec: '194I(a)', value: 1, other: 1, label: '194I(a) Rent For Plant & Machinery [1%]' },
  { id: 54, sec: '194N', value: 2, other: 2, label: '194N Payment of certain amounts in cash [2%]' },
  { id: 57, sec: '194NF', value: 1, other: 1, label: '194NF Payment of certain amounts [1%]' },
];
